var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding-top":"200px","text-align":"center","font-size":"36px","font-weight":"bold","width":"100%"}},[_vm._v("链接已失效")])
}
var staticRenderFns = []

export { render, staticRenderFns }